﻿<script>
	import { navigate } from "svelte-navigator";

	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";

	export let heading;
	export let routeId;
	export let showEdit = true;

	const editPage = () => {
		navigate(routeId);
	};
</script>

<FormRow class="justify-content-center confirmation-show">
	<FormColumn cols="10">
		<h2>{@html heading ? heading : "&nbsp;"}</h2>
	</FormColumn>
	{#if showEdit}
		<FormColumn class="text-end">
			<button class="btn-edit" type="submit" on:click|preventDefault={editPage}>EDIT</button>
		</FormColumn>
	{/if}
</FormRow>

<style>
	h2 {
		margin-bottom: 0 !important;
		margin-top: 16px;
	}

	.btn-edit {
		position: relative;
		color: var(--color-body);
		background-color: transparent;
		border: none;
		padding: 0;
		padding-left: 26px;
		font-family: "Proxima Nova";
		font-weight: 600;
		font-size: 11px;
		margin-top: 34px;
	}

	.btn-edit:before {
		font-family: "FontAwesome";
		position: absolute;
		content: "\f044";
		font-size: 1rem;
		line-height: 1;
		left: 0;
	}

	@media print {
		.btn-edit {
			display: none;
		}

		.btn-edit:before {
			content: "";
		}
	}
</style>
